import useTranslation from 'next-translate/useTranslation';
import styles from './styles.module.scss';
import SkeletonFavoriteCard from './Skeleton';
import FavoriteCardTable from './FavoriteCardTable';
import { usePlayerStatistics } from '@/api/players';
import { useProfileModalVariant } from '@/hooks/theme/variants/useProfileModalVariant';
import { SettingLayoutComponentId } from '@starsoft/common/models';

export default function FavoriteCard() {
  const { t } = useTranslation('common');
  const { isPending } = usePlayerStatistics();
  const { version } = useProfileModalVariant();

  if (isPending) {
    return <SkeletonFavoriteCard />;
  }

  return (
    <div className={styles.container}>
      <p
        className={`${styles.container__title} ${version === SettingLayoutComponentId.UserProfileV2?.toString() ? styles['container__title--v2'] : ''}`}
      >
        {t('modalProfile_top3FavoriteGames')}
      </p>
      <div
        className={`${styles.container__wrapper} ${
          version === SettingLayoutComponentId.UserProfileV2?.toString()
            ? styles['container__wrapper--v2']
            : ''
        }`}
      >
        <FavoriteCardTable />
      </div>
    </div>
  );
}
